// Generated by CoffeeScript 1.11.1
(function() {
  var ICC;

  module.exports = ICC = (function() {
    ICC.prototype.id = 1039;

    ICC.prototype.name = 'icc profile';

    function ICC(resource) {
      this.resource = resource;
      this.file = this.resource.file;
      this.start = this.file.pos;
      this.end = this.start + this.resource.length;
    }

    ICC.prototype.parse = function() {
      return this.file.data.subarray(this.start, this.end);
    };

    return ICC;

  })();

}).call(this);
